<template>
    <div style="background: #fff;height:100%">
        <Headers :title="title" />
        <van-row style="padding:0 .28rem 0 .28rem">
            <van-col  class="exhibitior-wrap"  v-for="(item, index) in videoSource" :key="index" span="8">
                <template>
                    <div class="exhibitior-wrap-img">
                            <video ref="videoPlay" class="video" :src="src" controls  controlslist="nodownload noremoteplayback"></video>
                    </div>
                    <div class="exhibitior-wrap-title">
                        <div class="palce-store">
                            <div class="palce">
                                <span class="palce-name">{{item.name}}</span>
                            </div>
                            <div v-if="item.is_mark == 0" class="store" @click.stop="isCollect(item)">
                                <img class="store-icon" src="~statics/mobileShouye/unstore.png" alt="">
                                <span class="store-name">{{$t('detail').collect}}</span>
                            </div>
                            <div v-else class="store" @click.stop="noCollect(item)">
                                <img class="store-icon"  src="~statics/mobileShouye/store.png" alt="">
                                <span class="store-name">{{$t('detail').uncollect}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
// import Footers from "./components/Footers";
import { mapState } from "vuex";
import api from "@/api";

export default {
    
    data(){
        return{
            list: [],
            loading: false,
            finished: false,
            title: '视频列表',
            src: '',
            videoSource: [],
            videoSourceImg: [],
            instance_id: null,
            videoImgList: [],
            exhibition_id: '',
            store: null
        }
    },
    computed: {
        // language(){
        //     return localStorage.getItem('language') || 'zh'
        // },
        // title(){
        //     return this.language == 'zh' ? '视频列表' : 'Video List'
        // },
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.instance_id = this.$route.query.instance_id;
        this.exhibition_id = this.$route.query.exhibition_id
        this.getExhibitionVideo()

    },
    mounted(){
        console.log(this.userInfo);
    },
    methods: {
        // handleCollect(item){
        //     if(!this.userInfo.id) {
        //         this.$notice({ type: 'danger', message: '请先登录后收藏' });
        //         return
        //     }else{
        //         if(item.is_mark == 0){
        //             this.isCollect(item)
        //             return
        //         }else{
        //             this.noCollect(item)
        //             return
        //         }
        //     }
        // },
        // 收藏视频
        isCollect(item) {
            api.isCollectVideo({
                exhibition_id: this.exhibition_id,
                resource_id: item.fileId
            }).then((res) => {
                // console.log(res);
                item.is_mark = 1;
                this.$notify({ type: 'success', message: '收藏成功' });
            });
        },
        // 取消视频收藏
        noCollect(item) {
            api.noCollectVideo({
                exhibition_id: this.exhibition_id,
                resource_id: item.fileId
            }).then((res) => {
                // console.log(res);
                item.is_mark = 0;
                this.$notify("取消收藏");
            });
        },
        // getSnapshot(str) {
        //     api.getSnapshot(str).then((res) => {
        //         console.log(res);
        //         if (res.res == 1) {
        //             this.videoImgList = res.list;
        //         }
        //     });
        // },
        onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                for (let i = 0; i < 10; i++) {
                this.list.push(this.list.length + 1);
                }

                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if (this.list.length >= 40) {
                this.finished = true;
                }
            }, 1000);
        },
        getExhibitionVideo() {
            api.getExhibitionVideo({
               exhibition_id: this.exhibition_id,
                hall_id: this.instance_id,
                type: "video"
            }).then((res) => {
                console.log("视频列表", res);
                if (!res.data || !res.data.length) {
                    this.$notify({ type: 'warning', message: this.$t("tips").noVideo });
                    return;
                }
                this.videoSource = res.data;
                let videoImgList = [];
                res.data.map((value) => {
                    console.log(value.fileId);
                    videoImgList.push(value.fileId);
                });
                if (res.data.length) {
                    this.src = res.data[0].url;
                    let str = videoImgList.join(",");
                    this.getSnapshot(str);
                }
            });
        },
        play(item, index) {
            this.videoSource.map((item) => (item.playFlag = true));
            this.src = item.url;
            // this.src = item.resource.view_url;
            item.playFlag = false;
            this.activeNum = index;
            this.$refs.videoPlay.play();
        },
        stop(item) {
            this.$refs.videoPlay.pause();
            item.playFlag = true;
        },
    },
    components: {
        Headers
    },
    computed: {
        videoList() {
            return this.$t("videoList");
        }
    },
    watch: {
        videoSource(val) {
            // console.log(val);
            if (val) {
                val.map((item) => {
                    this.$set(item, "playFlag", true);
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.exhibitior-wrap{
    &:nth-child(1){
        margin-top: .3rem;
    }
    &:nth-last-child(){
        margin-bottom: .3rem;
    }
    width: 6.9rem;
    height: 4.86rem;
    margin-bottom: .48rem;
    // background: #f2f7ff;
    border-radius: 7px;
    .exhibitior-wrap-img{
        width: 6.92rem;
        height: 4.2rem;
        background: #fff;
        video {
            width: 100%;
            height: 100%;
        }
    }
    .exhibitior-wrap-title{
        display: flex;
        flex-direction: column;
        height: 1.3rem;
        margin-top: .24rem;
        // margin: .24rem .28rem .28rem .28rem;
        .exhibitior-wrap-title-name{
            color: #333333;
            line-height: .42rem;
            height: .42rem;
            font-size: 16px;
            // overflow: hidden; 
            // white-space: nowrap; 
            // text-overflow: ellipsis;
        }
        .palce-store{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .palce{
                display: flex;
                .palce-name{
                    // width: 1.32rem;
                    height: .42rem;
                    color: #333;
                    font-size: 16px;
                    line-height: .42rem;
                }
            }
            .store{
                display: flex;
                justify-content: center;
                align-items: center;
                .store-icon{
                    width: .24rem;
                    height: .24rem;
                    margin-right: .1rem;
                }
                .store-name{
                    line-height: .3rem;
                    color: #999;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileVideoList/index.vue